export default __webpack_public_path__ + "static/media/telugu_lang.a2ed276d.png";